import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "../components/ui/dropdown-menu";
import { useUiStore, type PlatformOverride } from "../store/uiStore";

const OPTIONS: { value: PlatformOverride; label: string }[] = [
  { value: "auto", label: "Auto" },
  { value: "desktop", label: "Desktop" },
  { value: "tablet", label: "Tablet" },
  { value: "phone", label: "Phone" },
];

/** Layout: Auto / Desktop / Tablet / Phone, device-local. */
export function PlatformOverrideMenu() {
  const platformOverride = useUiStore((s) => s.platformOverride);
  const setPlatformOverride = useUiStore((s) => s.setPlatformOverride);

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        Layout: {OPTIONS.find((o) => o.value === platformOverride)?.label}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuRadioGroup
          value={platformOverride}
          onValueChange={(v) => setPlatformOverride(v as PlatformOverride)}
        >
          {OPTIONS.map((o) => (
            <DropdownMenuRadioItem key={o.value} value={o.value}>
              {o.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
